import { h, Component } from 'preact';
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSTransition from 'react-transition-group/CSSTransition';

// Constants
import { stepComponents } from '../../../constants/Steps';
import Icon from '../../Global/Icon';
import { checkConditions } from '../../../utilities/package/packageUtils';

class Coverage extends Component {
  constructor(props) {
    super(props);
    const { showDescription } = this.props;

    this.state = {
      showDesc: showDescription,
      variantClass: '',
    };
  }

  render() {
    const {
      variant,
      coverageList,
      coverageMerge,
      coverageVariation,
      coverageCode,
      userData,
      name,
      isValid,
      errors,
      touched,
      setValues,
      values,
      dispatch,
      onChange,
      onBlur,
      showTitle,
      serviceName,
      overrideTitle,
      showDescription,
      callBack,
      product,
    } = this.props;

    let showHide = true;
    let { showDesc, variantClass } = this.state;

    const getLinkReadMore = function (title, listProps) {
      const ButtonComponent = stepComponents.button;
      const buttonParams = {
        id: coverageCode,
        type: 'button',
        variant: 'text',
        label: title,
        actions: [
          {
            actionType: 'modal',
            props: {
              modalType: listProps ? 'info' : 'coverage',
              props: [{
                type: 'coverage',
                variant: 'modal',
                coverageCode,
              }],
            },
          },
        ],
        isValid,
        errors,
        touched,
        setValues,
        values,
        dispatch,
        onChange,
        onBlur,
      };
      if (listProps) {
        return {
          button: ButtonComponent,
          params: buttonParams,
        };
      }
      return <ButtonComponent {...buttonParams} />;
    };
    let hasLong = false;
    let title = '';
    let desc = '';
    let missingCode = false;
    if (!coverageList[coverageCode]) {
      if (coverageMerge) {
        if (!coverageMerge[coverageCode]) {
          missingCode = true;
        }
      } else {
        missingCode = true;
      }
      if (missingCode) {
        console.warn(`Can't find coverage code: ${coverageCode}`); // eslint-disable-line
        return '';
      }
    }
    if (showTitle &&
      (coverageList[coverageCode] || (coverageMerge && coverageMerge[coverageCode]))) {
      title =
        coverageList[coverageCode] ?
          coverageList[coverageCode].name :
          coverageMerge[coverageCode].name;
      if (variant === 'modal' && (
        (coverageList[coverageCode] && coverageList[coverageCode].modalTitle) ||
        (coverageMerge && coverageMerge[coverageCode] && coverageMerge[coverageCode].modalTitle)
      )) {
        title =
          coverageList[coverageCode] ?
            coverageList[coverageCode].modalTitle :
            coverageMerge[coverageCode].modalTitle;
      }
      if (callBack) {
        showHide = callBack(title.length, coverageCode);
      }
    }
    if (overrideTitle) {
      title = overrideTitle;
    }
    if (variant === 'recommendationTitle') {
      title = coverageList[coverageCode] && coverageList[coverageCode].recommendTitle ? coverageList[coverageCode].recommendTitle : '';
      if (coverageVariation && coverageVariation[coverageCode]) {
        // Do coverage variation based on conditions.
        coverageVariation[coverageCode]
          .filter(
            coverage => checkConditions(coverage.conditions,
              { ...userData, PRODUCT: product })
          )
          .forEach(
            coverage => {
              title = coverage.recommendTitle;
            }
          );
      }
    }
    if (showDescription) {
      if (coverageVariation && coverageVariation[coverageCode]) {
        if (coverageList[coverageCode]) {
          desc =
            variant === 'recommendation' ?
              coverageList[coverageCode].recommendDesc :
              coverageList[coverageCode].shortDesc;
        } else {
          desc =
            variant === 'recommendation' ?
              coverageMerge[coverageCode].recommendDesc :
              coverageMerge[coverageCode].shortDesc;
        }
        // Do coverage variation based on conditions.
        coverageVariation[coverageCode]
          .filter(
            coverage => checkConditions(coverage.conditions,
              { ...userData, PRODUCT: product })
          )
          .forEach(
            coverage => {
              desc = (variant === 'recommendation' ? coverage.recommendDesc : coverage.shortDesc);
            }
          );
      } else if (coverageList[coverageCode]) {
        desc = coverageList[coverageCode].shortDesc;
      } else if (coverageMerge && coverageMerge[coverageCode]) {
        desc = coverageMerge[coverageCode].shortDesc;
      }
    }
    if (showDescription && (
      (coverageList[coverageCode] && coverageList[coverageCode].longDesc) ||
      (coverageVariation && coverageVariation[coverageCode]) ||
      (coverageMerge && coverageMerge[coverageCode] && coverageMerge[coverageCode].longDesc)
    )) {
      hasLong = true;
      if (variant === 'modal') {
        if (showDescription) {
          if (coverageVariation && coverageVariation[coverageCode]) {
            // Do coverage variation based on conditions.
            coverageVariation[coverageCode]
              .filter(
                coverage => checkConditions(coverage.conditions, userData)
              )
              .forEach(
                coverage => {
                  if (coverage.longDesc) {
                    desc = coverage.longDesc;
                  }
                }
              );
          } else if (coverageList[coverageCode] && coverageList[coverageCode].longDesc) {
            desc = coverageList[coverageCode].longDesc;
          } else if (coverageMerge &&
            coverageMerge[coverageCode] &&
            coverageMerge[coverageCode].longDesc) {
            desc = coverageMerge[coverageCode].longDesc;
          }
        }
      }
    }
    let InputComponent = null;
    let params = null;
    switch (variant) {
      case 'modal':
        InputComponent = stepComponents.textBlock;
        params = {
          title,
          desc,
          titleClass: 'modal__title--coverage',
          dispatch,
        };
        break;

      case 'text':
        InputComponent = stepComponents.textBlock;
        params = {
          title,
          type: 'textBlock',
          desc,
          isValid,
          errors,
          touched,
          setValues,
          values,
          dispatch,
          onChange,
          onBlur,
        };
        if (hasLong) {
          params.descMore = getLinkReadMore('Læs mere');
        }
        break;

      case 'name':
        InputComponent = stepComponents.textBlock;
        params = {
          title,
          type: 'textBlock',
        };
        break;

      case 'nameText':
        InputComponent = stepComponents.textBlock;
        params = {
          desc: title,
          type: 'textBlock',
        };
        break;

      case 'listProps': {
        const readMore = getLinkReadMore(title, true);
        InputComponent = readMore.button;
        ({ params } = readMore);
        break;
      }

      case 'accordion': {
        // TODO: Handle CoverageMerge in the future.
        let description = desc;
        if (showDesc) {
          description = null;
        }
        InputComponent = stepComponents.checkbox;
        params = {
          id: coverageCode,
          type: 'checkbox',
          label: title,
          isValid,
          errors,
          touched,
          setValues,
          values,
          dispatch,
          onChange,
          onBlur,
          options: [
            {
              label: title,
              id: coverageCode,
              name,
              desc: description,
              actions: [
                {
                  actionType: 'callServices',
                  props: {
                    useSpinner: true,
                    services: [
                      {
                        serviceName,
                        serviceParams: [
                          {
                            field: 'policyID',
                            required: true,
                          },
                          {
                            field: 'coverageCodes',
                            required: true,
                            valueFrom: 'coverageCodes',
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  actionType: 'scrollToTop',
                  props: {
                    scrollElement: 'productbox__outer',
                  },
                },
              ],
            },
          ],
        };
        if (hasLong) {
          params.options[0].descMore = getLinkReadMore('Læs mere');
        }
        break;
      }

      case 'checkbox':
        // TODO: Handle CoverageMerge in the future.
        InputComponent = stepComponents.checkbox;
        params = {
          id: coverageCode,
          type: 'checkbox',
          label: title,
          isValid,
          errors,
          touched,
          setValues,
          values,
          dispatch,
          onChange,
          onBlur,
          options: [
            {
              label: title,
              id: coverageCode,
              name,
              desc,
              actions: [
                {
                  actionType: 'callServices',
                  props: {
                    useSpinner: true,
                    services: [
                      {
                        serviceName,
                        serviceParams: [
                          {
                            field: 'policyID',
                            required: true,
                          },
                          {
                            field: 'coverageCodes',
                            required: true,
                            valueFrom: 'coverageCodes',
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  actionType: 'scrollToTop',
                  props: {
                    scrollElement: 'productbox__outer',
                  },
                },
              ],
            },
          ],
        };
        if (hasLong) {
          params.options[0].descMore = getLinkReadMore('Læs mere');
        }
        break;

      case 'recommendation':
        InputComponent = stepComponents.textBlock;
        params = {
          desc,
          type: 'textBlock',
        };
        break;
      case 'recommendationTitle':
        InputComponent = stepComponents.textSimple;
        params = {
          value: title,
          component: 'span',
          className: 'recommendation-trans',
          type: 'textSimple',
        };
        break;

      default:
        console.warning('Unknown variant "' + variant + '" for coverage code "' + coverageCode + '"'); // eslint-disable-line
    }

    const showHideDescription = () => {
      showDesc = !showDesc;
      if (!showDesc) {
        variantClass = 'accordion--active';
      } else {
        variantClass = '';
      }

      this.setState({
        showDesc,
        variantClass,
      });
    };

    return (
      <CSSTransition
        in={showHide}
        timeout={300}
        classNames="fadeIn"
        unmountOnExit
      >
        <div className={variantClass}>
          <InputComponent {...params} />
          {variant === 'accordion' &&
          <button type="button" className="accordion__title" onClick={() => showHideDescription()}>
            <span>
              <Icon icon="chevronDown" fill="red"/>
            </span>
          </button>
          }
        </div>
      </CSSTransition>
    );
  }
}

export default compose(
  connect(state => {
    const {
      section: {
        packageData: {
          initialValues: {
            coverageList,
            coverageMerge,
            coverageVariation,
          },
        },
      },
      userData,
    } = state;
    return {
      coverageList,
      coverageMerge,
      coverageVariation,
      userData,
    };
  })
)(Coverage);

Coverage.defaultProps = {
  styling: null,
  name: null,
  showDescription: true,
  showTitle: true,
  serviceName: '',
  overrideTitle: null,
  callBack: null,
  product: null,
};

Coverage.propTypes = {
  coverageList: PropTypes.object.isRequired,
  coverageMerge: PropTypes.object.isRequired,
  coverageVariation: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  variant: PropTypes.string.isRequired,
  coverageCode: PropTypes.string.isRequired,
  styling: PropTypes.string,
  name: PropTypes.string,
  isValid: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  showDescription: PropTypes.bool,
  showTitle: PropTypes.bool,
  serviceName: PropTypes.string,
  overrideTitle: PropTypes.string,
  callBack: PropTypes.func,
  product: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Steps/General/Coverage.jsx